import { render, staticRenderFns } from "./LinkCarte.vue?vue&type=template&id=0f30727f"
import script from "./LinkCarte.vue?vue&type=script&lang=js"
export * from "./LinkCarte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports